import $ from 'jquery'
import 'slick-carousel'

$(document).ready(function () {
  dhsv_vc_downloads_media()
})

function dhsv_vc_downloads_media() {
  $('.dhsv_vc_downloads_media').each(function () {})

  $('.js-downloads-slider').slick({
    dots: true,
    rows: 2,
    slidesPerRow: 4,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesPerRow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesPerRow: 1,
        },
      },
    ],
  })

  $('.dhsv_vc_downloads_media').on('click', '.js-downloads-item', function () {
    const targetModal = $($(this).data('target'))
    const slideIndex = $(this).data('slide-index')
    const $slider = targetModal.find('.js-downloads-modal-slider')
    $slider.css({
      height: 0,
      opacity: 0,
    })

    targetModal.on('shown.bs.modal', function () {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick')
      }

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        initialSlide: slideIndex,
      })

      $slider.css({
        height: 'auto',
        opacity: 1,
      })
    })

    targetModal.modal('show')
  })
}
